(function () {
    // vip 订阅选择
    const gridItems = document.querySelectorAll('.grid-item');
    const targetItem = window.PlanManager.getSelectedPlan() === 'prime' ? 2 : 1;
    gridItems[targetItem]?.classList.add('active');

    gridItems.forEach((item, index) => {
      if (index === 0) return;

      item.addEventListener('click', () => {
        document.querySelectorAll('.grid-item').forEach(el =>
          el.classList.remove('active')
        );
        item.classList.add('active');
        triggerPlanButton(index);
      });
    });

    // 高级会员slide效果
    const wrapper = document.querySelector('.wrapper');
    const track = wrapper.querySelector('.prome_offers');
    const dots = wrapper.querySelectorAll('.slides li');

    const TOTAL = dots.length; // 3
    let index = 0;
    let timer = null;
    const INTERVAL = 10000;

    function goTo(i) {
    index = i;
    track.style.transform = `translateX(-${index * 33.33}%)`;

    dots.forEach((dot, idx) => {
        dot.classList.toggle('active', idx === index);
    });
    }

    function next() {
    index = (index + 1) % TOTAL;
    goTo(index);
    }

    function start() {
    if (timer) return;
    timer = setInterval(next, INTERVAL);
    }

    function stop() {
    clearInterval(timer);
    timer = null;
    }

    // 鼠标悬停暂停
    wrapper.addEventListener('mouseenter', stop);
    wrapper.addEventListener('mouseleave', start);

    // 手动点击 dots
    dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
        stop();
        goTo(i);
        start();
    });
    });

    // 初始化
    goTo(0);
    start();


    // Q & A 前两个单词加span标签
    const questions = document.querySelectorAll('.collapsible-content .collapsible-content-wrapper-narrow details .accordion__title');

    questions.forEach(el => {
        wrapFirstTwoWordsInElement(el);
    })
})();

function wrapFirstTwoWordsInElement(el, className = 'highlight') {
  const text = el.textContent.trim();
  el.innerHTML = text.replace(
    /^(Q\d+[.:、．])/,
    `<span class="${className}">$1</span>`
  );
}

function triggerPlanButton(index) {
  const button = document.querySelector(
    `[data-plan-button="${index}"]`
  );
  if (!button) return;

  button.click();
}